import { render } from "./NcCard.vue?vue&type=template&id=f8f1a586"
import script from "./NcCard.vue?vue&type=script&lang=js"
export * from "./NcCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__